// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__SEPvj"};